import { SuiteApiClient } from "@weco/suite-client";
import type { BillingStatus } from "./types";

/**
 * People's own API root as the browser reaches it (same prefix the admin
 * module's billing calls use — `/api/people/<path>` is rewritten to People by
 * nginx and the dev proxy alike; a bare `/api/v1.0` falls through to the SPA's
 * index.html). Paths keep their leading slash: SuiteApiClient concatenates.
 */
const peopleApi = new SuiteApiClient("/api/people/api/v1.0");

export interface CheckoutStarted {
  checkout_url: string;
  reference: string;
}

export const billingApi = {
  status: () => peopleApi.get<BillingStatus>("/billing/status/"),
  /** Opens a Paymob checkout for one of the caller's organization's bills. */
  pay: (statementId: string) =>
    peopleApi.post<CheckoutStarted>(`/billing/statements/${statementId}/pay/`, {}),
  /** Opens Paymob's checkout to save (or replace) the card bills are charged to. */
  saveCard: () => peopleApi.post<CheckoutStarted>("/billing/card/", {}),
};
